export default "__VITE_ASSET__cdd68479__"